import { sharedDeDE, sharedEnUS, sharedEsES, sharedNlNL } from '@griply/assets';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { deDE, enUS, esES, Locales, nlNL } from 'shared/assets/localization';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: Locales.EnUS,
    resources: {
      [Locales.EnUS]: { translation: { ...sharedEnUS, ...enUS } },
      [Locales.NlNL]: { translation: { ...sharedNlNL, ...nlNL } },
      [Locales.EsES]: { translation: { ...sharedEsES, ...esES } },
      [Locales.DeDE]: { translation: { ...sharedDeDE, ...deDE } },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
    },
  });

// Update HTML lang attribute when language changes
const updateHtmlLang = (lng: string) => {
  document.documentElement.setAttribute(
    'lang',
    lng === Locales.EnUS ? 'en' : 'nl',
  );
};

// Set initial language
updateHtmlLang(i18n.resolvedLanguage ?? i18n.language);

// Listen for language changes
i18n.on('languageChanged', updateHtmlLang);

export default i18n;
